export default "__VITE_ASSET__70385211__"